import { MutationTree, ActionTree, Module } from 'vuex';
import { RootState, AttributeCountsState } from './../types';
import FRTBApi from '@/api/frtb.api';

import _ from 'lodash';

const state: AttributeCountsState = {
  queuedRequests: [],
  queryActive: false,
  counts: {}
};

const mutations: MutationTree <AttributeCountsState> = {
  setAttrValues(attributeCountsState, counts: any = {}) {
    attributeCountsState.counts = counts;
  },
  setQueuedAttrValueRequests(attributeCountsState, queuedRequests: any = {}) {
    attributeCountsState.queuedRequests = queuedRequests;
  },
  setAttrValueQueryActive(attributeCountsState, queryActive: boolean = false) {
    attributeCountsState.queryActive = queryActive;
  },
};

const actions: ActionTree <AttributeCountsState, RootState> = {
  async getAttrValues(context, { basicProfile, force }) {
    if (context.state.queryActive && !force) {
      context.commit('setQueuedAttrValueRequests', basicProfile);
      context.commit('setAttrValueQueryActive', true);
    } else {
      context.commit('setAttrValueQueryActive', true);
      try {
        const res = await FRTBApi.getAttrValues(basicProfile);
        if (_.isEmpty(context.state.queuedRequests)) {
          context.commit('setAttrValues', res);
          context.commit('setQueuedAttrValueRequests');
          context.commit('setAttrValueQueryActive', false);
        } else {
          const queuedBasicProfile = context.state.queuedRequests;
          context.commit('setQueuedAttrValueRequests');
          context.dispatch('getAttrValues', {basicProfile: queuedBasicProfile, force: true});
        }
      } catch (e) {
        context.commit('setAttrValueQueryActive', false);
        context.commit('setToastError', 'Error getting attribute counts.');
      }
    }
  }
};

export const attributeCounts: Module<AttributeCountsState, RootState> = {
  state,
  mutations,
  actions
};
